/// <reference path="../common-types.d.ts" />
import axios, { AxiosResponse } from 'axios'

export const getAuthStatus = async (): Promise<AxiosResponse> =>  {
    return await axios(`${appSettings.ApiUrl}/api/identity/auth-status`, { withCredentials: true });
}